<template>
  <div class="main">
    <!-- 搜索及筛选 -->
    <div class="whiteBg main-top">
      <el-row>
        <el-col :span="6">
          <div class="box box-align-center mt-input">
            <div class="mti-txt">Banner名称：</div>
            <el-input v-model="artName" style="width: 200px;" placeholder="请输入名称" clearable></el-input>
          </div>
        </el-col>

        <el-col :span="2" :offset="9">
          <div class="box box-align-center box-pack-end mt-btns">
            <el-button type="primary" icon="el-icon-search" @click="getList()">搜索</el-button>
            <el-button plain icon="el-icon-refresh" @click="resetList">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 新增文章按钮 -->
    <div class="whiteBg main-middle">
      <div class="box box-align-center mt-btns">
        <el-button type="primary" plain icon="el-icon-plus" @click="buildNewTopic">新增</el-button>
      </div>
      <dy-table :columns="columns" style="margin-top: 12px" :table-data="tableData" ref="fbTable"
        v-loading="tableLoading" :total="total" :page-num="currentPage" :page-size="pageSize"
        @current-change="onCurrentChange" element-loading-text="加载中"></dy-table>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="addVisible" width="60%" destroy-on-close
      :close-on-click-modal="false">
      <el-form :model="ruleForm" :rules="rules" label-width="110px" label-position="right" ref="ruleForm">
        <!-- <el-row> -->
        <!-- <el-col :span="10"> -->
        <el-form-item label="Banner名称：" prop="bannerName">
          <el-input v-model="ruleForm.bannerName" placeholder="请输入Banner名称"></el-input>
        </el-form-item>
        <el-form-item label="Banner图片" required prop="bannerUrl">
          <el-upload class="upload-demo" :action="uploadImg" name="file"
              :on-success="handlePosterPreview" :headers="headers"  :show-file-list="false" list-type="picture-card">
              <div v-if="!ruleForm.bannerUrl">
                  <i class="el-icon-upload"></i>
                  <!-- <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div> -->
              </div>
              <div v-else>
                  <img :src="ruleForm.bannerUrl" alt="">
              </div>
          </el-upload>
          <div style="font-size: 13px;">建议上传图片尺寸：2倍图 690 x 264px</div>
                <!-- <img v-if="form.channelName" :src="form.channelName" style="width: 147px; height: 147px" />
                <div v-else style="color:#606266">上传图片</div> -->
            
            <!-- <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog> -->

          </el-form-item>
        <!-- </el-col> -->
        <!-- <el-col :span="10" :offset="1"> -->

        <!-- </el-col> -->
        <!-- </el-row> -->
        <!-- <el-row class="mt12">
          <el-col :span="10"> -->
        <el-form-item label="跳转类型：" prop="jumpType">
          <el-select v-model="ruleForm.jumpType" placeholder="请选择跳转类型">
            <el-option v-for="item in jumpChooseData" :key="item.jumpType" :label="item.jumpname" :value="item.jumpType">
            </el-option>
          </el-select>
        </el-form-item>
        <div v-if="ruleForm.jumpType == 2">
          <el-form-item label="网址：" prop="newUrl">
          <el-input v-model="ruleForm.newUrl" placeholder="请输入网址"></el-input>
        </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="跳转：" prop="jumpAudioId">
          <el-select v-model="ruleForm.jumpAudioId" filterable placeholder="请选择跳转类型">
            <el-option v-for="item in jumpData" :key="item.audioId" :label="item.audioName" :value="item.audioId">
            </el-option>
          </el-select>
        </el-form-item>
        </div>

        
        <el-form-item label="按钮权重：" prop="sort">
          <el-input v-model="ruleForm.sort" placeholder="数字越小排名越靠前"></el-input>
        </el-form-item>
        <el-form-item label="生效日期" prop="calendarStartTime">
            <div class="block">
                <el-date-picker
              v-model="ruleForm.calendarStartTime"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
                </el-date-picker>
            </div>
        </el-form-item>
        <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px; margin-right: 30px">
          <el-button type="primary" plain @click="submitForm('ruleForm')">保存</el-button>
          <el-button type="danger" plain @click="() => (addVisible = false)">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!-- <el-dialog title="推广位配置" :visible.sync="addChapterVisible" width="60%" :close-on-click-modal="false"
      destroy-on-close>
      <el-button type="primary" icon="el-icon-plus" @click="() => (showAddArticleVisible = true)">添加推广位</el-button>
      <dy-table :columns="chapterColumns" rowKeyName="unionId" style="margin-top: 12px" :isShowPager="false"
        :table-data="chapterTableData" @onDragEnd="(arr) => { bfChapterTableData = arr }" ref="fbTable"
        v-loading="chapterTableLoading" element-loading-text="加载中"></dy-table>
      <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px; margin-right: 30px">
        <el-button type="primary" plain @click="submitFormChapter()">保存</el-button>
        <el-button type="danger" plain @click="() => (addChapterVisible = false)">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加推广位" append-to-body width="70%" :visible.sync="showAddArticleVisible" destroy-on-close
      :close-on-click-modal="false">
      <channel-common @close-dialog="() => (showAddArticleVisible = false)" @save-data="getSelection"
        :list="chapterTableData"></channel-common>
    </el-dialog> -->
  </div>
</template>
<script>
import DyTable from '@/components/common/dytable';
import channelCommon from '@/components/common/channelCommon/index';
import host from '@/api/index';
import { getChannelList, editChannel, ChannelListupdate,releaseChannel, deleteChannel, saveChooseSpreadSpace, getChannelContent,getAddBanner,getJumpBanner,getUpateBanner,BannerTo,BannerDelete,subBanner } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';
import { formatDate, uniqueBy, arrToStr, strToArr } from '@/utils/utils';
import { pushUserType, operatingSystemPhone, statusList, channelType, spreadSpaceType } from '@/utils/commonData';
var that = null;
export default {
  components: {
    DyTable,
    channelCommon,
  },
  data() {
    const { addChannel } = this;
    const { delArticle } = this;
    const { offlineTopic } = this;
    const { onLineTopic } = this;
    const { editArticle } = this;
    const { delDialogArticle } = this;
    return {
      url1 :'',
      addBanner:'',
      jumpData:'',
      jumpChooseData:[
                { jumpType: '1', jumpname: '音频' },
                { jumpType: '2', jumpname: '网页' }
            ],
      canzuoPerson: localStorage.getItem('userId'),
      showAddArticleVisible: false,
      artName: null,
      pushUserType,
      operatingSystemPhone,
      channelType,
      statusList,
      activeName: 'first',
      tableLoading: true,
      topicId: '',
      dialogTitle: '新建/修改',
      columns: [
        {
          type: 'index',
          title: '序号',
        },
        {
          key: 'bannerName',
          title: 'Banner名称',
        },
        {
          key: 'bannerUrl',
          title: 'Banner预览',
          render: ({ row }) => {
              return (
                <div>
                   <img src={row.bannerUrl}  style="width:90%"  alt="" />
                </div>
              );

          },
        },
        {
          // key: 'startTime' + 'startTime',
          key: 'timeToget',
          title: '生效时间',
        },
        {
          key: 'username',
          title: '操作人',
        },
        {
          key: 'status',
          title: '状态',
          render: ({ row }) => {
            if (row.status == 1) {
              return (
                <div>
                  <el-tag type='warning' plain  round size='medium '>
                    待发布
                  </el-tag>
                </div>
              );
            } else if (row.status == 2) {
              return (
                <div>
                  <el-tag type='success' plain round size='medium  '>
                    已发布
                  </el-tag>
                </div>
              );
            } else {
              return (
                <div>
                  <el-tag type='info' plain round size='medium '>
                    已下线
                  </el-tag>
                </div>
              );
            }
          },
        },
        {
          key: '',
          title: '操作',
          width: '240px',
          render: ({ row }) => {
            if (row.status == '0' || row.status == '1') {
              return (
                <div>
                  <el-link type='warning' onClick={() => onLineTopic(row.id)}>
                    上线
                  </el-link>
                  <el-link type='primary' style='margin-left:12px' onClick={() => editArticle(row)}>
                    编辑
                  </el-link>
                  <el-link type='danger' style='margin-left:12px' onClick={() => delArticle(row.id)}>
                    删除
                  </el-link>
                </div>
              );
            } else {
              return (
                <div>
                  <el-link type='warning' class="ml12"  onClick={() => offlineTopic(row.id)}>
                    下线
                  </el-link>
                  <el-link type='primary' style='margin-left:12px' onClick={() => editArticle(row)}>
                    编辑
                  </el-link>
                  <el-link type='danger' style='margin-left:12px' onClick={() => delArticle(row.id)}>
                    删除
                  </el-link>

                </div>
              );
            }
          },
        },
      ],
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      ruleForm: {
        //新建频道
        bannerId:'',
        bannerName: '',
        bannerUrl: '',
        jumpAudioId: '',
        jumpType:'',
        sort: '',
        calendarStartTime:{startTime:'',endTime:''},

        newUrl:'',
        // startTime: '',
        // endTime: '',
      
      },
      rules: {
        bannerName: [{ required: true, message: '请输入Banner名称', trigger: 'blur' }],
        bannerUrl: [{ required: true, message: '请输入Banner图片', trigger: 'blur' }],
        jumpAudioId: [{ required: true, message: '请选择跳转', trigger: 'blur' }],
        jumpType: [{ required: true, message: '请选择跳转类型', trigger: 'blur' }],
        newUrl: [{ required: true, message: '请输入网址', trigger: 'blur' }],
        sort: [{ required: true, message: '请选择按钮权重', trigger: 'change' }],
        calendarStartTime: [{ required: true, message: '请选择生效日期', trigger: 'change' }],
      },
      chapterTableLoading: true,
      chapterColumns: [
        {
          type: "drag",
          render: () => {
            return (
              <i class="el-icon-rank drag-class"></i>
            );
          }
        },
        {
          key: 'spreadSpaceTypeTxt',
          title: '推广位类型',
        },
        {
          key: 'name',
          title: '推广位内容名称',
        },
        {
          key: 'remark',
          title: '备注',
        },
        {
          key: 'status',
          title: '推广位状态',
          render: ({ row }) => {
            if (row.status == 0) {
              return (
                <div>
                  <el-button type='success' round size='mini'>
                    待发布
                  </el-button>
                </div>
              );
            } else if (row.status == 1) {
              return (
                <div>
                  <el-button type='primary' round size='mini'>
                    已发布
                  </el-button>
                </div>
              );
            } else {
              return (
                <div>
                  <el-button type='warning' round size='mini'>
                    已下线
                  </el-button>
                </div>
              );
            }
          },
        },
        {
          key: '',
          title: '操作',
          render: ({ row, index }) => {
            return (
              <div>
                <el-link type='danger' onClick={() => delDialogArticle(row)}>
                  删除
                </el-link>
              </div>
            );
          },
        },
      ],
      chapterTableData: [],
      bfChapterTableData: [], //删除后备份，保存使用
      addVisible: false,
      addChapterVisible: false,
      value: '',
      status: null,
      currentAdd: null, //当前编辑的推广位
      currentTgwId: '', //设置推广位 ID
    };
  },
  mounted() {
    that = this;
    that.getList();
  },
  computed: {
    uploadImg() {
      return host.uploadImgUrl;
    },
    headers() {
      return {
        'bg-token': localStorage.getItem('token'), // 直接从本地获取token就行
      };
    },
  },
  methods: {
    //上传图片
    handlePosterPreview(file) {
            console.log(file);
            this.ruleForm.cover = file.data.name;
            this.url1 =  process.env.VUE_APP_API_URL_UPLOAD
            // console.log("1111",process)
            console.log(this.url1 + '/upload/' + file.data.name)
            this.ruleForm.bannerUrl  = this.url1 + '/upload/' + file.data.name
            this.$nextTick(() => {
              this.$forceUpdate()
            })
        },
    changeDateTime() {
      console.log('changeDateTime', that.ruleForm.endTime)
    },
    //保存选择后的数据
    getSelection(arr) {
      console.log('getSelection----', arr)
      let data = arr.map((item, index) => {
        return {
          id: item.id,
          name: item.name,
          remark: item.remark,
          status: item.status,
          spreadSpaceType: item.spreadSpaceType,
          spreadSpaceTypeTxt: item.spreadSpaceTypeTxt,
          isDelete: false,
          unionId: item.unionId
        };
      });
      // let currentArr = JSON.parse(JSON.stringify(that.chapterTableData.concat(data)));
      // that.chapterTableData = uniqueBy(currentArr, 'id');
      that.chapterTableData = data;
      console.log('保存', that.chapterTableData);
      that.bfChapterTableData = JSON.parse(JSON.stringify(that.chapterTableData));
    },
    //新建频道
    buildNewTopic() {
      that.dialogTitle = '新建/修改';
      that.addBanner  = true
      that.ruleForm= {
        bannerName: '',
        bannerUrl: '',
        jumpAudioId: '',
        sort: '',
        jumpType:'',
        newUrl:'',
        // calendarStartTime:{startTime:'',endTime:''},
        calendarStartTime:'',
        // startTime: '',
        // endTime: '',
        userId: '',
      };
      console.log(that.ruleForm)
      that.addVisible = true;
    },
    //重置列表
    resetList() {
      that.currentPage = 1;
      that.artName = null;
      that.status = null;
      that.getList();
    },
    //编辑频道
    editArticle(obj) {
      that.dialogTitle = '新建/修改';
      console.log(obj, '编辑');
      // that.ruleForm = obj;
      // that.ruleForm.platform = that.ruleForm.platform.length > 0 ? strToArr(that.ruleForm.platform) : '';
      // that.ruleForm.userType = that.ruleForm.userType.length > 0 ? strToArr(that.ruleForm.userType) : '';
      that.addVisible = true;
      that.addBanner = false
      that.getupdateToBanner(obj.id)
    },
    //删除频道
    delArticle(id) {
      that.$confirm('确认要删除此吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let info = {
          id: id,
          userId: localStorage.getItem('userId'),
        };
        console.log(info);
        var data = info;
        BannerDelete(data).then((res) => {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          });
          that.getList();
        });
      });
    },
    //删除弹窗里文章
    delDialogArticle(obj) {
      console.log(obj);
      let index = that.chapterTableData.findIndex((item) => item.id == obj.id);
      that.chapterTableData.splice(index, 1);
      that.bfChapterTableData = JSON.parse(JSON.stringify(that.chapterTableData));
    },
    // 下线频道
    offlineTopic(id) {
      that
        .$confirm('确认要下线吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let info = {
            id: id,
            userId: localStorage.getItem('userId'),
            status: 0,
          };
          console.log(info);
          // var data = info;
          var data = info;
          ChannelListupdate(data).then((res) => {
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success',
            });
            that.getList();
          });
        });
    },
    // 上线频道
    onLineTopic(id) {
      that
        .$confirm('确认要上线吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let info = {
            id: id,
            status: 2,
            userId: localStorage.getItem('userId'),
          };
          debugger;
          console.log(info);
          var data = info;
          BannerTo(data).then((res) => {
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success',
            });
            that.getList();
          });
        });
    },
    saveChooseSpreadSpace() {
      let obj = {
        channelId: that.currentTgwId,
        list: that.bfChapterTableData.map((item) => {
          return {
            id: item.id,
            name: item.name,
            remark: item.remark,
            spreadSpaceType: item.spreadSpaceType,
          };
        }),
      };
      console.log(obj, '保存管理信息');
      var data = encrypt(JSON.stringify(obj));
      saveChooseSpreadSpace(data).then((res) => {
        if (res.result == 1) {
          this.addChapterVisible = false;
          that.getList();
          this.$message({
            showClose: true,
            message: '保存成功',
            type: 'success',
          });
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });

    },
    // 保存推广位配置信息
    submitFormChapter() {
      if (that.bfChapterTableData.length == 0) {
        this.$message({
          showClose: true,
          message: '请添加推广位',
          type: 'error',
        });
        return;
      }
      if (that.currentAdd.status == 1) {//发布的需要提醒
        this.$confirm('保存后的内容将自动展示到APP，确认保存？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.saveChooseSpreadSpace();
        }).catch(() => {
          console.log('取消');
        });
        return;
      }
      that.saveChooseSpreadSpace();
    },
    //编辑
    editChannel() {
      var info = that.ruleForm;
      info.platform = that.ruleForm.platform ? arrToStr(that.ruleForm.platform) : '';
      info.userType = that.ruleForm.userType ? arrToStr(that.ruleForm.userType) : '';
      console.log(info, '我是表单');
      var data = info;
      editChannel(data).then((res) => {
        if (res.result == 1) {
          console.log(res);
          this.addVisible = false;
          that.currentPage = 1;
          that.getList();
          this.$message({
            showClose: true,
            message: '保存成功',
            type: 'success',
          });
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    // 提交表单
    submitForm(formName) {
      that.$refs[formName].validate((valid) => {
        if (valid) {

          if(that.addBanner){
            var info = {
                bannerName: that.ruleForm.bannerName,
                bannerUrl: that.ruleForm.bannerUrl,
                jumpAudioId: that.ruleForm.jumpAudioId,
                sort: that.ruleForm.sort,
                jumpType:that.ruleForm.jumpType,
                newUrl:that.ruleForm.newUrl,
                startTime: that.TimeStamp(that.ruleForm.calendarStartTime[0]),
                endTime:  that.TimeStamp(that.ruleForm.calendarStartTime[1]),
                userId: localStorage.getItem('userId'),
            };
          }else{
            var info = {
                id: that.ruleForm.bannerId,
                bannerName: that.ruleForm.bannerName,
                bannerUrl: that.ruleForm.bannerUrl,
                jumpAudioId: that.ruleForm.jumpAudioId,
                jumpType:that.ruleForm.jumpType,
                newUrl:that.ruleForm.newUrl,
                sort: that.ruleForm.sort,
                startTime: that.TimeStamp(that.ruleForm.calendarStartTime[0]),
                endTime:  that.TimeStamp(that.ruleForm.calendarStartTime[1]),
                userId: localStorage.getItem('userId'),
            };
          }

          console.log(info);
          var data = info;
          if(that.addBanner){
          console.log("新增")
          getAddBanner(data).then((res) => {
          if (res.result == 1) {
              that.getList();
              that.dialogTableAdd = false;
              that.addVisible = false
          } else {
              that.$message({
                  showClose: true,
                  message: res.msg,
                  type: 'error'
              });
          }
          });
          }else{
          console.log("修改")
          subBanner(data).then((res) => {
          if (res.result == 1) {
            that.getList();
              that.dialogTableAdd = false;
              that.addVisible = false
          } else {
              that.$message({
                  showClose: true,
                  message: res.msg,
                  type: 'error'
              });
          }
          });
          }
          // if (that.ruleForm.startTime && that.ruleForm.endTime && (new Date(that.ruleForm.startTime).getTime() >= new Date(that.ruleForm.endTime).getTime())) {
          //   return that.$message({
          //     message: '开始时间不能大于结束时间',
          //     type: 'warning',
          //   });
          // }
          // if (that.dialogTitle == '编辑频道' && that.ruleForm.status == 1) {//发布的需要提醒
          //   this.$confirm('保存后的内容将自动展示到APP，确认保存？', '提示', {
          //     confirmButtonText: '确定',
          //     cancelButtonText: '取消',
          //     type: 'warning'
          //   }).then(() => {
          //     that.editChannel();
          //   }).catch(() => {
          //     console.log('取消');
          //   });
          //   return;
          // }
          // that.editChannel();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
      //转换为时间戳
      TimeStamp(date){
        console.log("data",date)
        let timestampInMilliseconds = date.getTime();
        let timestampInSeconds = Math.floor(timestampInMilliseconds / 1000);
        return timestampInSeconds;
    },
    //将时间戳转换回来
    convertTimestampToDateTimeRange(serverTimestamp) {
        // 将10位时间戳转换为毫秒级时间戳
        let timestampInMilliseconds = serverTimestamp * 1000;
        let Timedate = new Date(timestampInMilliseconds);
        Timedate = new Date(Timedate.getTime()); 
        // console.log("回显时间",Timedate)
        return Timedate
    },
    //添加推广位
    addChannel(row) {
      console.log('1111', row);
      // if (row.status == 1) {
      //   this.$message({
      //     message: '请先将该频道下线',
      //     type: 'warning',
      //   });
      //   return;
      // }
      that.currentAdd = row;
      that.currentTgwId = row.channelId;
      that.getChannelContent();
      that.addChapterVisible = true;
    },
    onCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    //频道已选择推广位列表
    getChannelContent() {
      let info = {
        channelId: that.currentTgwId,
      };
      console.log(info);
      var data = info;
      getChannelContent(data).then((res) => {
        if (res.result == 1) {
          var ress = JSON.parse(decrypt(res.data));
          console.log('已选择推广位列表', ress);
          that.chapterTableData = ress.map((item) => {
            let txt = spreadSpaceType.find(obj => obj.value == item.spreadSpaceType);
            return {
              ...item,
              spreadSpaceTypeTxt: txt ? txt.label : '',
            };
          });
          that.bfChapterTableData = JSON.parse(JSON.stringify(that.chapterTableData));
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
      //获取直播数据
      getJump() {
        var that=this
        var info = {

        };
        console.log("---",info)
        var data = info;
        getJumpBanner(data).then((res) => {
            
            if (res.result == 1) {
                // var ress = JSON.parse(decrypt(res.data.replace(/[\r\n]/g, '')));
                var ress = res.data;
                console.log('直播数据',ress);
                that.jumpData = ress

            } else {
                that.$message({
                    showClose: true,
                    message: res.msg,
                    type: 'error'
                });
            }
        });
    },
    // 编辑列表数据
    getupdateToBanner(id) {
      that.tableLoading = true;
      let info = {
        id:id
      };
      console.log(info);
      var data = info;
      getUpateBanner(data).then((res) => {
        if (res.result == 1) {
          that.getJump()
          // var ress = JSON.parse(decrypt(res.data));
          var ress = res.data;
          console.log('编辑列表', ress);

          that.ruleForm.bannerId = ress.id,
          that.ruleForm.bannerName  = ress.bannerName,
          that.ruleForm.bannerUrl = ress.bannerUrl,
          that.ruleForm.jumpAudioId = ress.jumpAudioId,
          that.ruleForm.jumpType = ress.jumpType,
          that.ruleForm.newUrl = ress.newUrl
          that.ruleForm.sort = ress.sort,
          that.ruleForm.calendarStartTime = [that.convertTimestampToDateTimeRange(ress.startTime), that.convertTimestampToDateTimeRange(ress.endTime)],

          that.tableLoading = false;
          that.chapterTableLoading = false;
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    // 列表数据
    getList() {
      that.tableLoading = true;
      let info = {
        // status: that.status,
        pageNum: that.currentPage,
        pageSize: that.pageSize,
        bannerName:that.artName
        // channelName: that.artName,
        // needPage: true,
      };
      console.log(info);
      var data = info;
      getChannelList(data).then((res) => {
        if (res.result == 1) {
          that.getJump()
          // var ress = res.data;
          var ress = res.data;
          console.log('频道列表', ress);
          that.total = ress.total;
          that.currentPage = ress.pageNum;
          that.tableData = ress.list.map((item) => {
            return {
              ...item,
              startTime: item.startTime ? formatDate(new Date(item.startTime), 'yyyy-MM-dd hh:mm:ss') : '',
              endTime: item.endTime ? formatDate(new Date(item.endTime), 'yyyy-MM-dd hh:mm:ss') : '',
              statusTxt: statusList[item.status].label,
              // channelTypeTxt: channelType[item.channelType - 1].label,
              timeToget: item.startTime +' --  ' + item.endTime
            };
          });
          that.tableLoading = false;
          that.chapterTableLoading = false;
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
  },
};

</script>
<style lang="scss" scoped>
/deep/.el-tabs__item {
  min-width: 100px;
  text-align: center;
  padding: 0;
}

/deep/.el-dropdown {
  margin-right: 10px;
}

/deep/.el-form-item__label {
  width: 120px !important;
}

/deep/.el-form-item__content {
  width: 180px !important;
}

/deep/.el-form-item__content {
  margin-left: 0 !important;
}

// /deep/.el-tabs__header {
//     margin: 0;
// }

.main-top {
  padding: 20px 15px;
  // border-bottom: 1px solid rgba(96, 98, 102, 0.2392);

  .mti-txt {
    white-space: nowrap;
  }
}

.main-middle {
  padding: 15px 11px;
}

.common-btns {
  padding: 0 22px 33px;
}
.common-btn {
    width: 76px;
    height: 32px;
    border-radius: 16px !important;
    box-sizing: border-box;
    overflow: hidden;
}
</style>
